import { EntityState, PayloadAction } from '@reduxjs/toolkit'
import { BaseSchema } from '../Schema/BaseSchema'

export default function createUpdateOneReducer<T> (
  state: EntityState<T>,
  payload: PayloadAction<T>,
) {
  const entity = payload.payload
  if (!entity || !(entity instanceof BaseSchema)) {
    return
  }

  const key = entity.id

  if (!(key in state.entities)) {
    state.ids.push(key)
  }

  state.entities[key] = entity
}
